/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import Header from '../../components/header/header.component'
import "./detail-page.styles.css"
import Parser from 'html-react-parser';
import gamesJson from "../../games.json"

export default function DetailPage({id}) {
    const game = gamesJson[id-1]

    return (
        <div className="detailPage">
            <Header/>
            <div className="entry-header">
                <div className="detail">
                    <h2>{game.name}</h2>
                    <ul>
                        {
                            Object.entries(game.tags).map(val => <li>{val[0]}: <strong>{val[1]}</strong></li>)
                        }
                    </ul>
                </div>
                <div className="img">
                    <img src={game.thumbnailUrl} alt="" />
                </div>
            </div>
            <div className="entry-desc">
            <div className="detail">
                    <h2>Game Description</h2>
                    <div>
                        {
                            Parser(game.description)
                        }
                    </div>
                </div>
                <div className="gallery">
                    {
                        game.screenshotUrl.map(val => <img src={val} alt="" />)
                    }
                </div>
            </div>
            <div className="repack-detail">
                <h2>Repack Details</h2>
                <ul>
                    {
                        Parser(game.repackFeatures)
                    }
                </ul>
            </div>
            <div className="download-details">
                <h2>Download Links</h2>
                <ul>
                    {
                        Parser(game.downloadLinks)
                    }
                    <li><a href="#">1337x | [magnet] [.torrent file only]</a></li>
                </ul>
            </div>
        </div>
    )
}
